"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Container_1 = __importDefault(require("../Container/Container"));
var DefaultWrapper = function (props) {
    var redirectURL = props.redirectURL, features = props.features;
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "wrapper has-".concat(features.length) }, { children: features.length !== 0 && features.map(function (feature) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "wrapper__item wrapper__item--".concat(feature.featureData.jackpotType.toLowerCase()) }, { children: (0, jsx_runtime_1.jsx)(Container_1.default, { feature: feature, featuresLength: features.length, redirectURL: redirectURL }) }), feature.id)); }) })));
};
exports.default = DefaultWrapper;
